import React from "react";
import "./TableInventory.css";
import moment from "moment";
import SearchLogo from "../../Assets/search-icon.png";

// Format angka ala Indonesia: 1.234,5
const formatNumberID = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0";
  return num.toLocaleString("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
};

const TableInventory = ({ data, setPopUpSearch, setDataPickHistory }) => {
  const rows = Array.isArray(data) ? data : [];

  return (
    <div className="ti-wrapper">
      <div className="ti-table">
        <div className="ti-row ti-head">
          <div className="ti-cell">Material</div>
          <div className="ti-cell ti-cell-num">Stock (Kg)</div>
          <div className="ti-cell">Updated By</div>
          <div className="ti-cell">Last Update</div>
          <div className="ti-cell"></div>
        </div>

        {rows.length === 0 ? (
          <div className="ti-empty">Tidak ada data</div>
        ) : (
          rows.map((obj, i) => {
            const splitNama = (obj?.updatedBy || "")
              .split(" ")
              .slice(0, 2)
              .join(" ");

            const weight = Number(obj?.weight) || 0;

            const handlePick = () => {
              setPopUpSearch(true);
              setDataPickHistory(obj);
            };

            return (
              <div
                className={i % 2 === 0 ? "ti-row" : "ti-row ti-row-odd"}
                key={obj?.material || i}
              >
                <div className="ti-cell ti-cell-main">{obj?.material}</div>
                <div
                  className={
                    weight < 0
                      ? "ti-cell ti-cell-num ti-negative"
                      : "ti-cell ti-cell-num"
                  }
                >
                  {formatNumberID(weight)} Kg
                </div>
                <div className="ti-cell">{splitNama}</div>
                <div className="ti-cell ti-cell-date">
                  {obj?.updateTime
                    ? moment(obj.updateTime).format("ddd MMM D YYYY - H:mm:ss")
                    : ""}
                </div>
                <div className="ti-cell ti-cell-action">
                  <button
                    type="button"
                    className="ti-action-btn"
                    onClick={handlePick}
                    aria-label="Lihat riwayat"
                    title="Lihat riwayat"
                  >
                    <img
                      className="ti-action-icon"
                      src={SearchLogo}
                      alt="search-logo"
                    />
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default TableInventory;
